import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

const IndicadorInventarioFormGroup = ({ iEnabled, iValue, fIsSubmitting }) => {
  return (
    <Field name='flagInventario'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          disabled={!iEnabled || fIsSubmitting}
          checked={iValue}
          id='checkbox-flagInventario'
          label='INVENTARIOS'
        />
      )}
    </Field>
  )
}

export default React.memo(IndicadorInventarioFormGroup)
